<div class="acs-modal" *ngIf="isOpen" [class]="'acs-modal--' + size">
  <div class="acs-modal__backdrop" (click)="onBackdropClick($event)">
    <div class="acs-modal__container" role="dialog" [attr.aria-labelledby]="title ? 'modal-title' : null" aria-modal="true">
      <div class="acs-modal__header" *ngIf="title || showCloseButton">
        <h2 id="modal-title" class="acs-modal__title" *ngIf="title">{{ title }}</h2>
        <acs-button 
          *ngIf="showCloseButton"
          variant="text" 
          size="small"
          class="acs-modal__close"
          (clicked)="close()"
          aria-label="Close modal">
          ✕
        </acs-button>
      </div>
      
      <div class="acs-modal__body">
        <ng-content></ng-content>
      </div>
      
      <div class="acs-modal__footer" *ngIf="hasFooterContent">
        <ng-content select="[slot=footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
